import * as TypeGraphQL from "type-graphql";
export var TradeAuditEventScalarFieldEnum;
(function (TradeAuditEventScalarFieldEnum) {
    TradeAuditEventScalarFieldEnum["id"] = "id";
    TradeAuditEventScalarFieldEnum["timestamp"] = "timestamp";
    TradeAuditEventScalarFieldEnum["eventId"] = "eventId";
    TradeAuditEventScalarFieldEnum["eventType"] = "eventType";
    TradeAuditEventScalarFieldEnum["symbol"] = "symbol";
    TradeAuditEventScalarFieldEnum["accountId"] = "accountId";
    TradeAuditEventScalarFieldEnum["tradeId"] = "tradeId";
    TradeAuditEventScalarFieldEnum["signalId"] = "signalId";
    TradeAuditEventScalarFieldEnum["orderId"] = "orderId";
    TradeAuditEventScalarFieldEnum["userId"] = "userId";
    TradeAuditEventScalarFieldEnum["systemId"] = "systemId";
    TradeAuditEventScalarFieldEnum["signatureJson"] = "signatureJson";
    TradeAuditEventScalarFieldEnum["custodyJson"] = "custodyJson";
    TradeAuditEventScalarFieldEnum["retentionPolicyId"] = "retentionPolicyId";
    TradeAuditEventScalarFieldEnum["immutable"] = "immutable";
    TradeAuditEventScalarFieldEnum["encrypted"] = "encrypted";
    TradeAuditEventScalarFieldEnum["complianceTags"] = "complianceTags";
    TradeAuditEventScalarFieldEnum["customTags"] = "customTags";
    TradeAuditEventScalarFieldEnum["eventData"] = "eventData";
    TradeAuditEventScalarFieldEnum["eventCategory"] = "eventCategory";
    TradeAuditEventScalarFieldEnum["severity"] = "severity";
    TradeAuditEventScalarFieldEnum["passed"] = "passed";
    TradeAuditEventScalarFieldEnum["createdAt"] = "createdAt";
    TradeAuditEventScalarFieldEnum["retentionDate"] = "retentionDate";
})(TradeAuditEventScalarFieldEnum || (TradeAuditEventScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(TradeAuditEventScalarFieldEnum, {
    name: "TradeAuditEventScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=TradeAuditEventScalarFieldEnum.js.map